import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const apiUrl = window.Glob.BASE_URL;


export function getUserList(data) {
  return fetch({
    url: apiUrl + '/api/User/GetUserList',
    method: 'post',
    data
  })
}
export function createUser(data) {
  return fetch({
    url: apiUrl + '/api/User/CreateUser',
    method: 'post',
    data
  })
}
export function updateUser(data) {
  return fetch({
    url: apiUrl + '/api/User/UpdateUser',
    method: 'post',
    data
  })
}
export function removeUser(data) {
  return fetch({
    url: apiUrl + '/api/User/RemoveUser?id='+data,
    method: 'post'
  })
}

export function recoverUser(data) {
  return fetch({
    url: apiUrl + '/api/User/RecoverUser?id='+data,
    method: 'post'
  })
}

export function getUser(data) {
  return fetch({
    url: apiUrl + '/api/User/GetUser?id='+data,
    method: 'post'
  })
}

export function getAccountByCellphone(data){
  return fetch({
    url: apiUrl + '/api/User/GetAccountByCellphone?cellphone='+data,
    method: 'post',
    noToken:true
  })
}

export function updatePassword(data) {
  return fetch({
    url: apiUrl + '/api/User/UpdatePassword',
    method: 'post',
    data  
  })
}



// WEBPACK FOOTER //
// ./src/api/userApi.js